<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header" style="display: flex; justify-content: space-between;">
        <h3>Parcel Info</h3>
        <div class="header-button-container">
            @if (!editMode) {
                <div>
                    @if (hasInstancePrivateView) {
                        <button type="button"
                                class="ace-btn btn-text has-icon"
                                (click)="launchChangeHistoryModal()">
                            <i class="fa fa-history"></i>
                        </button>
                    }
                    <button class="ace-btn btn-text has-icon btn-primary"
                            [hidden]="!hasEditPermission"
                            (click)="edit()">
                        <i class="fa fa-pencil"></i>
                    </button>
                    @if (loadingPermissions) {
                        <ws-ace-loader [inline]="true"></ws-ace-loader>
                    }
                </div>
            }
            @if (editMode) {
                <span>
                    <button class="ace-btn btn-text has-icon btn-primary btn-success"
                            [disabled]="serverAction"
                            (click)="save()">
                        <i class="fa fa-save"></i>
                    </button>
                    <button class="ace-btn btn-text has-icon btn-primary btn-danger"
                            [disabled]="serverAction"
                            (click)="cancel()">
                        <i class="fa fa-close"></i>
                    </button>
                </span>
            }
        </div>
    </div>
    <div class="panel-flat-body short">
        @if (serverAction) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        <div [hidden]="serverAction">
            @if (!editMode) {
                <parcel-info-panel-view [parcelViewDto]="parcelViewDto"
                                        [parcelAssessor]="parcelAssessor"
                                        [years]="years"
                                        [assessorDetailsRenderer]="assessorDetailsRenderer"
                                        (serverActionChange)="serverAction = $event"
                                        [hasEditPermission]="hasEditPermission"
                                        [stateAllowConsolidating]="stateAllowConsolidating">
                </parcel-info-panel-view>
            }
            @if (editMode) {
                <parcel-info-panel-edit [parcel]="parcelViewDto.parcel"
                                        [instanceId]="instanceId"
                                        [assessorDetailsRenderer]="assessorDetailsRenderer"
                                        [reloadAnnualGrid]="reloadAnnualGrid"
                                        (serverActionChange)="serverAction = $event"
                                        [years]="years"
                                        [assessors]="assessors"
                                        [taxRateSetup]="parcelViewDto.taxRateSetup"
                                        [ppReturnPreparationAllowed]="parcelViewDto.ppReturnPreparationAllowed"
                                        [stateAllowConsolidating]="stateAllowConsolidating">
                </parcel-info-panel-edit>
            }
        </div>
    </div>
</div>
